import { 
  Utensils, Car, Home, ShoppingBag, Gamepad2, 
  Plane, Coffee, Gift, Heart, Users, 
  DollarSign, CreditCard, Zap, Wifi 
} from 'lucide-react';

export const EXPENSE_CATEGORIES = [
  { id: 'food', name: 'Food & Dining', icon: Utensils, color: 'text-orange-600 bg-orange-100' },
  { id: 'transport', name: 'Transportation', icon: Car, color: 'text-blue-600 bg-blue-100' },
  { id: 'housing', name: 'Housing', icon: Home, color: 'text-green-600 bg-green-100' },
  { id: 'shopping', name: 'Shopping', icon: ShoppingBag, color: 'text-purple-600 bg-purple-100' },
  { id: 'entertainment', name: 'Entertainment', icon: Gamepad2, color: 'text-pink-600 bg-pink-100' },
  { id: 'travel', name: 'Travel', icon: Plane, color: 'text-indigo-600 bg-indigo-100' },
  { id: 'utilities', name: 'Utilities', icon: Zap, color: 'text-yellow-600 bg-yellow-100' },
  { id: 'internet', name: 'Internet & Phone', icon: Wifi, color: 'text-teal-600 bg-teal-100' },
  { id: 'gifts', name: 'Gifts', icon: Gift, color: 'text-red-600 bg-red-100' },
  { id: 'healthcare', name: 'Healthcare', icon: Heart, color: 'text-rose-600 bg-rose-100' },
  { id: 'other', name: 'Other', icon: DollarSign, color: 'text-gray-600 bg-gray-100' }
];

export const getCategoryById = (id) => {
  return EXPENSE_CATEGORIES.find(cat => cat.id === id) || EXPENSE_CATEGORIES[EXPENSE_CATEGORIES.length - 1];
};
